import Reveal from "@/components/feature/Reveal";
import { focusList } from "@/mocks/homeContent";

export default function FocusBar() {
  return (
    <section id="focus" className="border-b border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-page px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <div>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-[30px]">
                傍晚新料速览
              </h2>
              <p className="mt-2 text-sm text-foreground-600 md:text-base">
                从 17:40 开始，整点前后陆续更新，按时间排好，随手往下翻就行。
              </p>
            </div>
            <span className="inline-flex items-center gap-2 self-start rounded-full border border-secondary-200 bg-secondary-50 px-3.5 py-1.5 text-xs text-secondary-800 md:text-sm">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-history-line text-base" />
              </span>
              最近更新 20:20
            </span>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-7 flex gap-3 overflow-x-auto pb-2 scrollbar-thin md:mt-9">
            {focusList.map((item) => (
              <a
                key={item.time}
                href="#wall"
                className="group flex min-w-[260px] max-w-[280px] shrink-0 cursor-pointer flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:min-w-[300px] md:max-w-[320px] md:p-5"
              >
                <div className="flex items-center gap-2">
                  <span className="font-heading text-sm font-semibold text-primary-600">{item.time}</span>
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm leading-relaxed text-foreground-800 transition-colors group-hover:text-foreground-950 md:text-[15px]">
                  {item.title}
                </p>
                <span className="mt-auto inline-flex items-center gap-1 text-xs text-foreground-500">
                  接上这条
                  <span className="flex h-3.5 w-3.5 items-center justify-center transition-transform group-hover:translate-x-0.5">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </span>
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}